// src/features/feeds/FeedApi.ts

import { webApi } from '@/shared/api/WebApi';
import type { IListRes } from '@lib2/model/common/ListRes';
import type { FeedData, FeedCreateRequest } from '@/lib/types/Feed';

export class FeedApi {
  /** List feeds for a customer. Returns IListRes -- unwrap .data in hook. */
  static async getFeeds(cId: number): Promise<IListRes<FeedData>> {
    return webApi.get<IListRes<FeedData>>('feed', { cId });
  }

  /** Create a new feed. webApi.post(path, queryParams, body). */
  static async createFeed(cId: number, req: FeedCreateRequest): Promise<FeedData> {
    return webApi.post<FeedData>('feed', { cId }, req);
  }

  /** Update an existing feed. */
  static async updateFeed(cId: number, feedId: number, req: FeedCreateRequest): Promise<FeedData> {
    return webApi.post<FeedData>(`feed/${feedId}`, { cId }, req);
  }

  /** Batch activate feeds. */
  static async activateFeeds(cId: number, ids: number[]): Promise<void> {
    return webApi.post<void>('feed/activate', { cId }, { feedIds: ids });
  }

  /** Batch deactivate feeds. */
  static async deactivateFeeds(cId: number, ids: number[]): Promise<void> {
    return webApi.post<void>('feed/deactivate', { cId }, { feedIds: ids });
  }

  /** Batch delete feeds. */
  static async deleteFeeds(cId: number, ids: number[]): Promise<void> {
    return webApi.post<void>('feed/delete', { cId }, { feedIds: ids });
  }
}
